import {ChangeDetectionStrategy, Component, contentChildren, input} from '@angular/core';
import {AccordionPanelComponent} from './accordion-panel.component';

@Component({
	selector: 'dc-accordion',
	standalone: true,
	imports: [],
	template: ` <ng-content />`,
	styles: `
		:host {
			display: block;
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
	/**
	 * האם לאפשר פתיחת מספר פאנלים בו זמנית
	 * כאשר false - בלחיצה על פאנל חדש, הפאנל הפתוח ייסגר
	 */
	public readonly multipleOpen = input<boolean>(false);

	readonly panels = contentChildren<AccordionPanelComponent>(AccordionPanelComponent);

	/**
	 * פתיחת פאנל ספציפי וסגירת האחרים (אם צריך)
	 */
	public openPanel(panelToOpen: AccordionPanelComponent): void {
		// אם לא מאפשרים ריבוי פאנלים פתוחים, סגור את שאר הפאנלים
		if (!this.multipleOpen()) {
			this.panels().forEach(panel => {
				if (panel !== panelToOpen) {
					panel.collapse();
				}
			});
		}
	}
}
